<template>
  <div class="alert-popup" v-if="alertData.alertShow">
    <div class="alert-content" v-if="alertData.alertType === 'success'">
      <div class="alert-header">
        <span>{{ alertData.alertTitle }}</span>
      </div>
      <div class="alert-body">
        <p>{{ alertData.alertMessage }}</p>
      </div>
      <div v-if="alertData.alertConfirm" class="list-btn">
        <button class="container-button" @click="cancelSubmit">Batal</button>
        <button class="container-button" v-if="alertData.isSubmit">
          <div class="spinner-button"></div>
        </button>
        <button class="container-button" @click="btnAction" v-else>{{ alertData.btnText ? alertData.btnText : "Simpan" }}</button>
      </div>
      <div class="list-btn" v-else>
        <button class="container-button" @click="closeAlert">OK</button>
      </div>
    </div>
    <div class="alert-content" v-else>
      <div class="alert-header">
        <span class="material-icons">warning</span>
        <span>{{ alertData.alertTitle }}</span>
      </div>
      <div class="alert-body">
        <p>{{ alertData.alertMessage }}</p>
      </div>
      <div class="list-btn">
        <button v-if="alertData.waButton" class="container-button" @click="openWhatsApp">
          {{ alertData.waText || "Hubungi CS" }}
        </button>
        <button class="container-button" @click="closeAlert">OK</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AlertPopup",
  props: ["alertData", "actionFunction", "btnAction", "actionRedirect"],
  methods: {
    closeAlert() {
      if (this.alertData.alertType === "success") {
        if (this.alertData.alertAction) {
          this.$router.push(this.alertData.alertAction);
        } else {
          this.actionRedirect();
        }
      } else if (this.alertData.alertType === "warning") {
        if (typeof this.actionFunction === "function") {
          this.actionFunction();
        }
        this.$emit("closeAlert");
      } else {
        this.$emit("closeAlert");
      }
    },
    cancelSubmit() {
      this.actionFunction();
      this.$emit("closeAlert");
    },
    openWhatsApp() {
      // Default ke nomor WhatsApp Call Center RUMAT (sama dgn Footer).
      const raw = this.alertData.waNumber || "6285320002020";
      const number = String(raw).replace(/[^0-9]/g, "");
      window.open(`https://wa.me/${number}`, "_blank");
      this.$emit("closeAlert");
    },
  },
};
</script>

<style scoped>
@import url("./css/alert-popup.css");
</style>
